import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const DISPLAY_ON = 'SYSTEM/DISPLAY_ON';

export const displayOnActionSchema = objectSchemaOf<IDisplayOnAction>({
  type: Joi.string().required().valid(DISPLAY_ON),
});

export interface IDisplayOnAction {
  type: typeof DISPLAY_ON;
}

export const displayOn = actionCreator({
  type: DISPLAY_ON,
  schema: displayOnActionSchema,
});
